import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import mySupervisingReducer from './mySupervisingSlice';
import myTaskSlice from './myTaskSlice';
import leadReducer from './leadSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  user: userReducer,
  myTask:myTaskSlice,
  mySupervising: mySupervisingReducer,
  lead : leadReducer
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
